/* DAPS busy-moms LP — mobile sticky buy bar visibility.
   The bar itself comes from the theme's real buy module (daps-buy.js renders + syncs it).
   Here we only control WHEN it shows: hidden over the header/hero, slides in once the
   reasons list ([data-mbuy-start]) is reached, and hides again while the buy box (#buy)
   or the footer is on screen. Skipped entirely in the theme editor (designMode) so the
   bar is always visible while editing. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;

  function init() {
    var body = document.body;
    if (!body.classList.contains('lp-moms')) return;
    var start = document.querySelector('[data-mbuy-start]');
    var bar = document.querySelector('.buybar');
    if (!start || !bar) return false;
    var buy = document.querySelector('#buy');
    var foot = document.querySelector('.foot');
    body.classList.add('mbuy-managed');

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var show = start.getBoundingClientRect().top <= vh * 0.6;
      if (show && buy) {
        var b = buy.getBoundingClientRect();
        if (b.top < vh && b.bottom > 0) show = false;
      }
      if (show && foot) {
        var f = foot.getBoundingClientRect();
        if (f.top < vh && f.bottom > 0) show = false;
      }
      bar.classList.toggle('buybar--on', show);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    return true;
  }

  /* the buy module renders the bar after daps-buy.js inits — poll briefly until it exists */
  function boot() {
    if (init() !== false) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (init() !== false || tries > 50) clearInterval(iv);
    }, 100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
